import {Box} from '@mui/material';
import {styled} from '@mui/system';

export const CardDivider = styled('hr')(({theme}) => ({
  marginTop: '12px',
  marginBottom: '12px',
  width: '100%',
  borderStyle: 'none',
  borderBottom: `1px solid ${theme.palette.common.swatch['30']}`,
}));

export const CardContent = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: '1',
  overflowWrap: 'anywhere',
  maxWidth: '100%',
}));

export const CardHeader = styled(Box)(({theme}) => ({
  // [theme.breakpoints.down('sm')]: {
  //   textAlign: 'center',
  // },
}));
